"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericError = void 0;
class GenericError extends Error {
    constructor(errorCode, message, status, originalError) {
        super(message);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GenericError);
        }
        this.name = 'GenericError';
        this.errorCode = errorCode;
        this.status = status;
        this.originalError = originalError;
    }
}
exports.GenericError = GenericError;
